import Vue from 'vue'
import {
  Button,
  ButtonGroup,
  Select,
  Option,
  RadioButton,
  RadioGroup,
  Radio,
  Dialog,
  Input,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Message,
  Loading,
  Container,
  Header,
  Aside,
  Menu,
  Submenu,
  MenuItem,
  Main,
  Link,
  Row,
  Col,
  Tag,
  Carousel,
  CarouselItem,
  Cascader,
  Table,
  TableColumn,
  Pagination,
  Progress,
  Card,
  Tree,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Upload,
  DatePicker,
  TimeSelect,
  TimePicker,
  Timeline,
  TimelineItem,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Popover,
  InputNumber,
  Autocomplete,
  MessageBox,
  Switch,
  Slider,
  Rate,
  Breadcrumb,
  BreadcrumbItem,
  Alert,
  Tooltip
} from 'element-ui'
// import '../assets/css/element-variables.scss'

Vue.use(Button)
Vue.use(ButtonGroup)
Vue.use(Select)
Vue.use(Option)
Vue.use(RadioButton)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Input)
Vue.use(Form)
Vue.use(Dialog)
Vue.use(FormItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Main)
Vue.use(Link)
Vue.use(Row)
Vue.use(Col)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Cascader)
Vue.use(Progress)
Vue.use(Tag)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Card)
Vue.use(Loading.directive)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(DatePicker)
Vue.use(TimeSelect)
Vue.use(TimePicker)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Checkbox)
Vue.use(CheckboxButton)
Vue.use(CheckboxGroup)
Vue.use(Popover)
Vue.use(InputNumber)
Vue.prototype.$loading = Loading.service
Vue.prototype.$message = Message
Vue.use(Tree)
Vue.use(Upload)
Vue.use(Autocomplete)
Vue.use(Switch)
Vue.use(Slider)
Vue.use(Rate)
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$confirm = MessageBox.confirm
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Alert)
Vue.use(Tooltip)
